import React, { useEffect } from 'react';
import Header from '../../components/common/Header/Header'; // Import your Header
import Footer from '../../components/common/Footer/Footer'; // Import Footer
import teamImage from '../../assets/images/siridharini.jpeg';
import heroImage from '../../assets/images/ourstory-heroimage.png';
import ContactForm from '../../components/common/ContactForm/ContactForm';

const OurStoryPage = () => {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }, []);
  const styles = {
    pageContainer: {
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, sans-serif',
    },
    
    // Hero section styles
    heroSection: {
      backgroundImage: `url(${heroImage})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      minHeight: '70vh',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      position: 'relative',
      color: 'white',
    },
    heroContainer: {
      maxWidth: '1400px',
      margin: '0 auto',
      padding: '0 2rem',
      width: '100%',
    },
    heroContent: {
      maxWidth: '800px',
    },
    heroTitle: {
      fontSize: '4rem',
      fontWeight: '700',
      lineHeight: '1.1',
      marginBottom: '1.5rem',
      textTransform: 'uppercase',
      letterSpacing: '0.05em',
    },
    heroSubtitle: {
      fontSize: '1.3rem',
      lineHeight: '1.6',
      opacity: 0.95,
      maxWidth: '600px',
    },
    
    // Content sections
    contentSection: {
      padding: '5rem 0',
      backgroundColor: '#ffffff',
    },
    sectionContainer: {
      maxWidth: '1400px',
      margin: '0 auto',
      padding: '0 2rem',
    },
    sectionGrid: {
      display: 'grid',
      gridTemplateColumns: '1fr 400px',
      gap: '4rem',
      alignItems: 'center',
    },
    sectionTitle: {
      fontSize: '3rem',
      fontWeight: '700',
      color: '#2d5016',
      marginBottom: '1rem',
      textTransform: 'uppercase',
      letterSpacing: '0.02em',
    },
    sectionSubtitle: {
      fontSize: '2rem',
      color: '#b8860b',
      fontWeight: '300',
      textTransform: 'uppercase',
      letterSpacing: '0.1em',
    },
    contentText: {
      fontSize: '1.1rem',
      lineHeight: '1.8',
      color: '#4a5568',
      display: 'flex',
      flexDirection: 'column',
      gap: '1.5rem',
    },
    videoContainer: {
      position: 'relative',
      width: '100%',
      paddingBottom: '56.25%',
      height: 0,
      borderRadius: '12px',
      overflow: 'hidden',
      boxShadow: '0 20px 50px rgba(0, 0, 0, 0.15)',
    },
    videoEmbed: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      border: 'none',
    },
    
    // Impact section
    impactSection: {
      padding: '5rem 0',
      backgroundColor: '#f8fafc',
      textAlign: 'center',
    },
    impactTitle: {
      fontSize: '3rem',
      fontWeight: '700',
      color: '#2d5016',
      marginBottom: '1rem',
      textTransform: 'uppercase',
    },
    impactSubtitle: {
      fontSize: '2rem',
      color: '#b8860b',
      fontWeight: '300',
      textTransform: 'uppercase',
      letterSpacing: '0.1em',
      marginBottom: '3rem',
    },
    impactDescription: {
      fontSize: '1.2rem',
      lineHeight: '1.8',
      color: '#4a5568',
      maxWidth: '900px',
      margin: '0 auto 4rem auto',
    },
    impactGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      gap: '3rem',
      marginTop: '4rem',
    },
    impactCard: {
      textAlign: 'center',
      padding: '2rem',
    },
    impactIcon: {
      width: '80px',
      height: '80px',
      margin: '0 auto 1.5rem auto',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '2rem',
    },
    environmentalIcon: {
      backgroundColor: '#dcfce7',
      color: '#16a34a',
    },
    socialIcon: {
      backgroundColor: '#fef3c7',
      color: '#d97706',
    },
    economicalIcon: {
      backgroundColor: '#dbeafe',
      color: '#2563eb',
    },
    impactCardTitle: {
      fontSize: '1.3rem',
      fontWeight: '600',
      color: '#2d5016',
      marginBottom: '0.5rem',
    },
    
    // Vision section
    visionSection: {
      padding: '5rem 0',
      backgroundColor: '#ffffff',
    },
    visionGrid: {
      display: 'grid',
      gridTemplateColumns: '1fr 400px',
      gap: '4rem',
      alignItems: 'center',
    },
    visionImage: {
      width: '100%',
      height: '300px',
      objectFit: 'cover',
      borderRadius: '12px',
      boxShadow: '0 20px 50px rgba(0, 0, 0, 0.15)',
    },
    
    // Mission section
    missionSection: {
      padding: '5rem 0',
      backgroundColor: '#f8fafc',
    },
    missionGrid: {
      display: 'grid',
      gridTemplateColumns: '400px 1fr',
      gap: '4rem',
      alignItems: 'center',
    },
    missionImage: {
      width: '100%',
      height: '300px',
      objectFit: 'cover',
      borderRadius: '12px',
      boxShadow: '0 20px 50px rgba(0, 0, 0, 0.15)',
      position: 'relative',
    },
    missionImageWrapper: {
      position: 'relative',
      borderRadius: '12px',
      overflow: 'hidden',
    },
    actualShootOverlay: {
      position: 'absolute',
      bottom: '1rem',
      right: '1rem',
      backgroundColor: 'rgba(255, 255, 255, 0.95)',
      color: '#2d5016',
      padding: '0.5rem 1rem',
      borderRadius: '6px',
      fontSize: '0.8rem',
      fontWeight: '600',
      textTransform: 'uppercase',
    },
    
    // Why section
    whySection: {
      padding: '5rem 0',
      backgroundColor: '#ffffff',
      textAlign: 'center',
    },
    whyTitle: {
      fontSize: '3.5rem',
      fontWeight: '700',
      color: '#2d5016',
      marginBottom: '1rem',
      textTransform: 'uppercase',
    },
    whySubtitle: {
      fontSize: '2.5rem',
      color: '#b8860b',
      fontWeight: '300',
      textTransform: 'uppercase',
      letterSpacing: '0.1em',
      marginBottom: '3rem',
    },
    whyDescription: {
      fontSize: '1.2rem',
      lineHeight: '1.8',
      color: '#4a5568',
      maxWidth: '900px',
      margin: '0 auto',
    },
    
    // Team section
    teamSection: {
      padding: '5rem 0',
      backgroundColor: '#f8fafc',
      textAlign: 'center',
    },
    teamTitle: {
      fontSize: '3rem',
      fontWeight: '700',
      color: '#2d5016',
      marginBottom: '2rem',
      textTransform: 'uppercase',
    },
    teamDescription: {
      fontSize: '1.2rem',
      lineHeight: '1.8',
      color: '#4a5568',
      maxWidth: '800px',
      margin: '0 auto 3rem auto',
    },
    teamImage: {
      width: '100%',
      maxWidth: '900px',
      height: 'auto',
      borderRadius: '12px',
      boxShadow: '0 20px 50px rgba(0, 0, 0, 0.15)',
      margin: '0 auto',
      display: 'block',
    },
    
    // Responsive styles
    '@media (max-width: 1024px)': {
      sectionGrid: {
        gridTemplateColumns: '1fr',
        gap: '3rem',
        textAlign: 'center',
      },
      visionGrid: {
        gridTemplateColumns: '1fr',
        gap: '3rem',
      },
      missionGrid: {
        gridTemplateColumns: '1fr',
        gap: '3rem',
      },
      impactGrid: {
        gridTemplateColumns: '1fr',
        gap: '2rem',
      },
      heroTitle: {
        fontSize: '3rem',
      },
      sectionTitle: {
        fontSize: '2.5rem',
      },
    },
  };

  const getYouTubeEmbedUrl = (url) => {
    const videoId = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
    return videoId ? `https://www.youtube.com/embed/${videoId[1]}?rel=0&modestbranding=1` : '';
  };

  return (
    <div style={styles.pageContainer}>
      {/* Header */}
      <Header />
      
      {/* Hero Section */}
      <section style={styles.heroSection}>
        <div style={styles.heroContainer}>
          <div style={styles.heroContent}>
            <div style={{color: 'rgba(255, 255, 255, 0.8)', fontSize: '1.2rem', marginBottom: '1rem', textTransform: 'uppercase', letterSpacing: '0.1em'}}>
              ABOUT
            </div>
            <h1 style={styles.heroTitle}>
              SIRIDHARINI
            </h1>
            <p style={styles.heroSubtitle}>
              With high-yield farmlands and luxury infrastructure, we're the makers of extraordinary experiences 
              crafted to help you get the most out of your investment.
            </p>
          </div>
        </div>
      </section>

      {/* Combined Our Story and Our Impact Section */}
      <section style={{
        padding: '6rem 0',
        backgroundColor: '#ffffff',
        backgroundImage: `
          url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23f0f0f0' fill-opacity='0.4'%3E%3Ccircle cx='30' cy='30' r='2'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E"),
          linear-gradient(135deg, rgba(255,255,255,0.8) 0%, rgba(248,250,252,0.6) 100%)
        `,
        backgroundSize: '60px 60px, 100% 100%',
        backgroundPosition: '0 0, 0 0'
      }}>
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '0 2rem',
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: '6rem',
          alignItems: 'start'
        }}>
          {/* Our Story */}
          <div>
            <h2 style={{
              fontSize: '2.5rem',
              fontWeight: '700',
              color: '#2c5f5f',
              marginBottom: '2rem',
              textAlign: 'left'
            }}>
              OUR <span style={{
                color: '#E67E22',
                fontWeight: '300'
              }}>STORY</span>
            </h2>
            <div style={{
              fontSize: '1rem',
              lineHeight: '1.6',
              color: '#4a5568',
              textAlign: 'left'
            }}>
              <p style={{marginBottom: '1rem'}}>
                SiriDharini was launched by a group of like minded individuals with 
                the aim of creating a safe investment option for the eco-conscious.
              </p>
              <p style={{marginBottom: '1rem'}}>
                For this, we envisioned a program that enables us to nurture your 
                investment every step of the way, while also taking only those 
                actions that give back to the earth as much as is taken from it via 
                sustainable farming practices.
              </p>
              <p style={{marginBottom: '1rem'}}>
                Mindful of the core value of 'giving back', we are also passionate 
                about job creation at the grassroots level for which we give first 
                preference to locals for all on-ground jobs.
              </p>
              <p style={{marginBottom: '0'}}>
                SiriDharini is the embodiment of an establishment that puts the 
                future first while creating a luxurious paradise in the present.
              </p>
            </div>
          </div>

          {/* Video Section */}
          <div style={{
            position: 'relative',
            width: '100%',
            paddingBottom: '56.25%', // 16:9 aspect ratio
            backgroundColor: '#000',
            borderRadius: '8px',
            overflow: 'hidden'
          }}>
            <iframe
              src="https://www.youtube.com/embed/82voB1b5sZU"
              title="About Siridharini"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                border: 'none',
                borderRadius: '8px'
              }}
            />
          </div>
        </div>

        {/* Our Impact */}
        <div style={{
          textAlign: 'center',
          marginTop: '8rem',
          maxWidth: '1200px',
          margin: '8rem auto 0 auto',
          padding: '0 2rem'
        }}>
          <h2 style={{
            fontSize: '2.5rem',
            fontWeight: '700',
            color: '#2c5f5f',
            marginBottom: '2rem',
            textAlign: 'center'
          }}>
            OUR <span style={{
              color: '#E67E22',
              fontWeight: '300'
            }}>IMPACT</span>
          </h2>
          <p style={{
            fontSize: '1rem',
            lineHeight: '1.7',
            color: '#4a5568',
            textAlign: 'center',
            maxWidth: '800px',
            margin: '0 auto'
          }}>
            Giving back to the environment in thanks for its bounty is at the heart of our 
            ethos. We do this by employing green farming practices that transform 
            exhausted dry lands into sustainable farmland by improving soil health and 
            removing atmospheric carbon. Creating long term change that impacts the 
            overall robustness of surrounding flora and fauna is done via recharging 
            groundwater levels.
          </p>
        </div>
      </section>

      {/* Our Vision Section */}
      <section style={{
        padding: '5rem 0',
        backgroundColor: '#ffffff'
      }}>
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '0 2rem',
          display: 'grid',
          gridTemplateColumns: '1fr 600px',
          gap: '4rem',
          alignItems: 'center'
        }}>
          {/* Left side - Text Content */}
          <div>
            <h2 style={{
              fontSize: '2.5rem',
              fontWeight: '700',
              color: '#2c5f5f',
              marginBottom: '2rem',
              textAlign: 'left'
            }}>
              OUR <span style={{
                color: '#E67E22',
                fontWeight: '300'
              }}>VISION</span>
            </h2>
            <p style={{
              fontSize: '1rem',
              lineHeight: '1.6',
              color: '#4a5568',
              textAlign: 'left'
            }}>
              To build and maintain a sustainable and commercially viable plantations that 
              provides economic and social benefits to the investors.
            </p>
          </div>

          {/* Right side - Image */}
          <div style={{
            width: '100%',
            height: '400px',
            backgroundImage: `url(${require('../../assets/images/ourvision.jpg')})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            borderRadius: '12px',
            boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)'
          }}>
          </div>
        </div>
      </section>

      {/* Our Mission Section */}
      <section style={{
        padding: '5rem 0',
        backgroundColor: '#f8fafc'
      }}>
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '0 2rem',
          display: 'grid',
          gridTemplateColumns: '600px 1fr',
          gap: '4rem',
          alignItems: 'center'
        }}>
          {/* Left side - Image */}
          <div style={{
            width: '100%',
            height: '400px',
            backgroundImage: `url(${require('../../assets/images/ourmission.png')})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            borderRadius: '12px',
            boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)',
            position: 'relative'
          }}>
            <div style={{
              position: 'absolute',
              bottom: '1rem',
              right: '1rem',
              backgroundColor: 'rgba(255, 255, 255, 0.95)',
              color: '#2d5016',
              padding: '0.5rem 1rem',
              borderRadius: '6px',
              fontSize: '0.8rem',
              fontWeight: '600',
              textTransform: 'uppercase'
            }}>
              ACTUAL SHOOT ON SITE
            </div>
          </div>

          {/* Right side - Text Content */}
          <div>
            <h2 style={{
              fontSize: '2.5rem',
              fontWeight: '700',
              color: '#2c5f5f',
              marginBottom: '2rem',
              textAlign: 'left'
            }}>
              OUR <span style={{
                color: '#E67E22',
                fontWeight: '300'
              }}>MISSION</span>
            </h2>
            <p style={{
              fontSize: '1rem',
              lineHeight: '1.6',
              color: '#4a5568',
              textAlign: 'left'
            }}>
              Committed to building eco-conscious, peace loving farming community through 
              innovative and win-win-win processes by cultivating multi-billion cash rich crops.
            </p>
          </div>
        </div>
      </section>

      {/* Why SiriDharini Section */}
      <section style={{
        padding: '5rem 0',
        backgroundColor: '#ffffff',
        textAlign: 'center'
      }}>
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '0 2rem'
        }}>
          <h2 style={{
            fontSize: '3rem',
            fontWeight: '700',
            color: '#2c5f5f',
            marginBottom: '1rem',
            textTransform: 'uppercase'
          }}>
            WHY SIRIDHARINI
          </h2>
          <h3 style={{
            fontSize: '2.5rem',
            color: '#E67E22',
            fontWeight: '300',
            textTransform: 'uppercase',
            letterSpacing: '0.1em',
            marginBottom: '3rem'
          }}>
            FARMLANDS?
          </h3>
          <p style={{
            fontSize: '1.2rem',
            lineHeight: '1.8',
            color: '#4a5568',
            maxWidth: '900px',
            margin: '0 auto 4rem auto'
          }}>
            An investment that yields returns for both you and the earth might seem 
            like a pipe dream. But with SiriDharini, it can be your reality. Wondering 
            how? Land has always been considered a safe investment option that isn't 
            subject to massive fluctuations. With SiriDharini, you can exponentially 
            increase your returns with active farmlands that endow you with a passive 
            income without ever having to liquidate your assets.
          </p>

          {/* Process Steps */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(5, 1fr)',
            gap: '2rem',
            marginTop: '4rem'
          }}>
            {/* You Buy */}
            <div style={{
              textAlign: 'center',
              padding: '1.5rem'
            }}>
              <div style={{
                width: '80px',
                height: '80px',
                margin: '0 auto 1.5rem auto',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <img src={require('../../assets/images/youbuy.png')} alt="You Buy" style={{width: '60px', height: '60px', objectFit: 'contain'}} />
              </div>
              <h4 style={{
                fontSize: '1.1rem',
                fontWeight: '600',
                color: '#2c5f5f',
                marginBottom: '0.5rem'
              }}>
                You Buy
              </h4>
            </div>

            {/* We Grow */}
            <div style={{
              textAlign: 'center',
              padding: '1.5rem'
            }}>
              <div style={{
                width: '80px',
                height: '80px',
                margin: '0 auto 1.5rem auto',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <img src={require('../../assets/images/wegrow.png')} alt="We Grow" style={{width: '60px', height: '60px', objectFit: 'contain'}} />
              </div>
              <h4 style={{
                fontSize: '1.1rem',
                fontWeight: '600',
                color: '#2c5f5f',
                marginBottom: '0.5rem'
              }}>
                We Grow
              </h4>
            </div>

            {/* We Cultivate */}
            <div style={{
              textAlign: 'center',
              padding: '1.5rem'
            }}>
              <div style={{
                width: '80px',
                height: '80px',
                margin: '0 auto 1.5rem auto',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <img src={require('../../assets/images/wecultivate.png')} alt="We Cultivate" style={{width: '60px', height: '60px', objectFit: 'contain'}} />
              </div>
              <h4 style={{
                fontSize: '1.1rem',
                fontWeight: '600',
                color: '#2c5f5f',
                marginBottom: '0.5rem'
              }}>
                We Cultivate
              </h4>
            </div>

            {/* We Manage */}
            <div style={{
              textAlign: 'center',
              padding: '1.5rem'
            }}>
              <div style={{
                width: '80px',
                height: '80px',
                margin: '0 auto 1.5rem auto',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <img src={require('../../assets/images/wemanage.png')} alt="We Manage" style={{width: '60px', height: '60px', objectFit: 'contain'}} />
              </div>
              <h4 style={{
                fontSize: '1.1rem',
                fontWeight: '600',
                color: '#2c5f5f',
                marginBottom: '0.5rem'
              }}>
                We Manage
              </h4>
            </div>

            {/* You Earn */}
            <div style={{
              textAlign: 'center',
              padding: '1.5rem'
            }}>
              <div style={{
                width: '80px',
                height: '80px',
                margin: '0 auto 1.5rem auto',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <img src={require('../../assets/images/youearn.png')} alt="You Earn" style={{width: '60px', height: '60px', objectFit: 'contain'}} />
              </div>
              <h4 style={{
                fontSize: '1.1rem',
                fontWeight: '600',
                color: '#2c5f5f',
                marginBottom: '0.5rem'
              }}>
                You Earn
              </h4>
            </div>
          </div>
        </div>
      </section>

      {/* Our Team Section */}
      <section style={{
        padding: '4rem 0',
        backgroundColor: '#f8fafc',
        textAlign: 'center'
      }}>
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '0 2rem'
        }}>
          <h2 style={{
            fontSize: '3rem',
            fontWeight: '700',
            color: '#2c5f5f',
            marginBottom: '2rem',
            textTransform: 'uppercase'
          }}>
            OUR TEAM
          </h2>
          <p style={{
            fontSize: '1.1rem',
            lineHeight: '1.6',
            color: '#6b7280',
            maxWidth: '800px',
            margin: '0 auto 3rem auto'
          }}>
            Meet The Driving Forces Behind SiriDharini. With decades of experiences 
            in the finance industry, their professional prowess is complemented by a 
            passion for sustainability and organic farming.
          </p>
          <img 
            src={teamImage}
            alt="SiriDharini Team"
            style={{
              width: '100%',
              maxWidth: '1000px',
              height: 'auto',
              borderRadius: '12px',
              boxShadow: '0 20px 50px rgba(0, 0, 0, 0.15)',
              margin: '0 auto',
              display: 'block'
            }}
          />
        </div>
      </section>

      {/* Contact Form Section */}
      <ContactForm 
        pageSource="Our Story Page"
        title="Get In Touch"
        onSubmitSuccess={(result) => {
          console.log('Our Story page contact form submitted successfully:', result);
        }}
        onSubmitError={(error) => {
          console.error('Our Story page contact form submission failed:', error);
        }}
      />

      {/* Map Section */}
      <section style={{
        padding: '60px 0',
        backgroundColor: 'white'
      }}>
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '0 2rem'
        }}>
          <h2 style={{
            fontSize: '2rem',
            textAlign: 'center',
            marginBottom: '2rem',
            color: '#2d5016'
          }}>
            Our Farm Location
          </h2>
        </div>
        {/* Full-width map container */}
        <div style={{
          width: '100vw',
          position: 'relative',
          left: '50%',
          right: '50%',
          marginLeft: '-50vw',
          marginRight: '-50vw',
          overflow: 'hidden'
        }}>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2835.0184872672107!2d77.65422287387703!3d12.620336053815237!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae65e9bcb4a251%3A0x76b1620925218475!2sSiridharini!5e1!3m2!1sen!2sin!4v1784033535484!5m2!1sen!2sin"
            width="100%"
            height="500"
            style={{border: 0}}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="strict-origin-when-cross-origin"
            title="Siridharini Farmlands - 615/1, Gopasandra, Deverabetta Road"
          ></iframe>
        </div>
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '0 2rem'
        }}>
          <div style={{
            textAlign: 'center',
            marginTop: '1rem',
            color: '#666'
          }}>
            📍 Siridharini Farmlands<br />
            615/1, Gopasandra, Deverabetta Road<br />
            Next to Reed Relays & Electronics, Thali Post Denkanekote
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default OurStoryPage;